(function () {
  'use strict';

  function openPopup(popup) {
    popup.hidden = false;
    document.body.style.overflow = 'hidden';

    var panel = popup.querySelector('[data-ct-popup-panel]');
    if (panel) {
      panel.classList.remove('is-flipped');
      // Force reflow so the animation restarts every time it's reopened
      void panel.offsetWidth;
      panel.classList.add('is-flipped');
    }
  }

  function closePopup(popup) {
    popup.hidden = true;
    document.body.style.overflow = '';

    var panel = popup.querySelector('[data-ct-popup-panel]');
    if (panel) panel.classList.remove('is-flipped');
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-ct-popup-trigger]');
    if (trigger) {
      var id = trigger.getAttribute('data-ct-popup-trigger');
      var popup = document.getElementById(id);
      if (popup) openPopup(popup);
      return;
    }

    var scrollTopBtn = event.target.closest('[data-ct-scroll-top]');
    if (scrollTopBtn) {
      event.preventDefault();
      var popupToScrollClose = scrollTopBtn.closest('[data-ct-popup]');
      if (popupToScrollClose) closePopup(popupToScrollClose);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    var closeEl = event.target.closest('[data-ct-popup-close]');
    if (closeEl) {
      var popupToClose = closeEl.closest('[data-ct-popup]');
      if (popupToClose) closePopup(popupToClose);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-ct-popup]').forEach(function (popup) {
      if (!popup.hidden) closePopup(popup);
    });
  });
})();